import { useTranslation } from 'react-i18next';

import type { MyProfileDTO } from '@/api/adapters/my-profile';
import type { PortalRole } from '@/shared/types/auth';

import { LicenseNoField } from './LicenseNoField';
import { PhoneChangePanel } from './PhoneChangePanel';

const formatIsoToDot = (iso: string | null): string => {
  if (!iso) return '-';
  // Accepts "YYYY-MM-DD" or full ISO; takes just the date portion.
  const datePart = iso.slice(0, 10);
  return datePart.replace(/-/g, '.');
};

interface MyInfoCardProps {
  profile: MyProfileDTO;
}

export function MyInfoCard({ profile }: MyInfoCardProps) {
  const { t } = useTranslation('myProfile');

  const roleLabel = (role: PortalRole): string => {
    if (role === 'CRC') return t('roles.crc');
    return role === 'DOCTOR' ? t('roles.doctor') : t('roles.nurse');
  };

  return (
    <div className="card profile-card">
      <div className="card__header">
        <h3 className="card__title">{t('cards.myInfo.title')}</h3>
      </div>
      <div className="card__body">
        <div className="form-field">
          <label>{t('cards.myInfo.fields.email')}</label>
          <input type="text" value={profile.email} readOnly />
        </div>
        <div className="form-field">
          <label>{t('cards.myInfo.fields.name')}</label>
          <input type="text" value={profile.name} readOnly />
        </div>
        <div className="form-field">
          <label>{t('cards.myInfo.fields.phone')}</label>
          <PhoneChangePanel currentPhone={profile.phone} />
        </div>
        <div className="form-field">
          <label>{t('cards.myInfo.fields.licenseNo')}</label>
          <LicenseNoField currentLicenseNo={profile.licenseNo ?? null} />
        </div>
        <div className="form-field">
          <label>{t('cards.myInfo.fields.organization')}</label>
          <input type="text" value={profile.organization} readOnly />
        </div>
        <div className="form-field">
          <label>{t('cards.myInfo.fields.department')}</label>
          <input type="text" value={profile.department} readOnly />
        </div>
        <div className="form-field">
          <label>{t('cards.myInfo.fields.role')}</label>
          <input type="text" value={roleLabel(profile.role)} readOnly />
        </div>
        <div className="form-field">
          <label>{t('cards.myInfo.fields.joinedAt')}</label>
          <input type="text" value={formatIsoToDot(profile.joinedAt)} readOnly />
        </div>
      </div>
    </div>
  );
}
